import { clearDecimals } from "@local/utils/src/clearDecimals"

const USD_RATES: Record<string, number> = {
  USD: 1,
  EUR: 1.15,
  GBP: 1.33,
  CAD: 0.72,
  AUD: 0.69,
  NZD: 0.57,
  CHF: 1.25,
}

/**
 * Converts a major-unit amount (e.g. 49.99) to an approximate USD value.
 * Rounds to 2 decimal places.
 *
 * @param amount - The amount in major currency units (e.g. 49.99)
 * @param currency - The currency code used to look up the USD rate (e.g. "GBP")
 * @returns The approximate USD value, rounded to 2 decimal places
 */
export const convertMajorToUsd = (amount: number, currency: string): number => {
  const rate = USD_RATES[currency] ?? 1
  return clearDecimals(amount * rate, 2)
}

/**
 * Converts a cents-based amount to an approximate USD value.
 * Internally divides by 100 and rounds to 2 decimal places.
 *
 * @param cents - The amount in minor currency units (cents)
 * @param currency - The currency code used to look up the USD rate (e.g. "GBP")
 * @returns The approximate USD value, rounded to 2 decimal places
 */
export const convertToUsd = (cents: number, currency: string): number =>
  convertMajorToUsd(cents / 100, currency)
